<template>
  <div class="w-full px-20 mb-20">
    <div class="grid w-full grid-cols-12 px-16 py-16 mb-16 border border-light-gray-4">
      <div class="col-span-3">
        <img class="w-80 h-80 object-contain" :src="item.images.profileImage['sm']"
          :alt="item.images.altImage" />
      </div>
      <div class="grid items-center col-span-8 ml-10 mr-24 md:ml-0">
        <a :href="item.url">
          <p class="w-132 font-bold text-14 lg:text-16 text-orange title">
            {{ item.title }}
          </p>
        </a>
        <p class="text-12 lg:text-14">
          {{ item.artist.name }}
        </p>
        <p class="font-bold text-12 lg:text-14">
          {{ item.priceWithCurrency }}
        </p>
      </div>
      <div class="grid items-center justify-center col-span-1">
        <div class="focus:outline-none">
          <button type="button" @click="remove" :disabled="isDisabled" class="focus:outline-none">
            <i class="far fa-trash-alt text-22"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {

  props: {
    item: {
      type: Object,
      required: true,
    }
  },

  data() {
    return {
      isDisabled: false,
    }
  },

  remove() {
    this.isDisabled = true
  },

  methods: {
    remove() {
      this.isDisabled = true
      axios
        .post(`/web/api/cart/remove/${this.item.slug}`)
        .then(({ data }) => {
          this.isDisabled = false
          this.$emit('removed', this.item, data.data)
          this.$root.$refs.notification.notify({
            title: 'Artwork Removed!',
            message: 'The selected artwork is removed from your cart.',
            type: 'warning-dark',
          })
        })
        .catch((error) => {
          this.$root.$refs.notification.notify({
            title: 'Something went wrong!',
            message: "We can't remove this item at the moment. Please refresh the page and try again. Error: " +
              error.response.status,
            type: 'warning-dark',
          })
        })
    }
  },

}
</script>

<style lang="scss" scoped>
.title {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
